import { PropertyTypeNames } from '../../../system/property-type';

export const TOTAL_STEPS = 7;
export const STEP_DONE = 'STEP_DONE';

export const BACKGROUND_GRADIENTS = {
  [PropertyTypeNames.RESIDENTIAL]:
    'linear-gradient(214deg, #FCFCFB 17%, #EFF2FF 60.21%, #C9D2FF 109.63%)',
  [PropertyTypeNames.RESIDENTIAL_LEASE]:
    'linear-gradient(214deg, #FCFCFB 17%, #FFF4EF 60.21%, #FFDBC9 109.63%)',
  [PropertyTypeNames.BUSINESS_OPPORTUNITY]:
    'linear-gradient(214deg, #FCFCFB 17%, #EFF2FF 60.21%, #C9D2FF 109.63%)',
  [PropertyTypeNames.FARM]:
    'linear-gradient(214deg, #FCFCFB 17%, #DBF6F2 60.21%, #86E2D5 109.63%)',
  [PropertyTypeNames.LAND]:
    'linear-gradient(214deg, #FCFCFB 17%, #DBF6F2 60.21%, #86E2D5 109.63%)',
  [PropertyTypeNames.COMMERCIAL_LEASE]:
    'linear-gradient(214deg, #FCFCFB 17%, #EFF2FF 60.21%, #C9D2FF 109.63%)',
  [PropertyTypeNames.COMMERCIAL_SALE]:
    'linear-gradient(214deg, #FCFCFB 17%, #EFF2FF 60.21%, #C9D2FF 109.63%)',
  [PropertyTypeNames.MULTI_FAMILY]:
    'linear-gradient(214deg, #FCFCFB 17%, #FFF4EF 60.21%, #FFDBC9 109.63%)',
} as const;
